export default __webpack_public_path__ + "static/media/PROCESS_STEP4_XS.f8acc2b2.png";